import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import classNames from 'classnames';
import React from 'react';
import Link from './Link';

const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
  },
  link: {
    fontSize: '1rem',
    color: `${theme.palette.text.secondary} !important`,
    '&:hover': {
      color: `${theme.palette.primary.light} !important`,
    },
  },
  denseListItem: { paddingTop: 4, paddingBottom: 0 },
}));

function Footer({ className }: { className?: string }) {
  const { classes } = useStyles();

  const listItemProps = {
    dense: true,
    disableGutters: true,
    classes: { dense: classes.denseListItem },
  };

  return (
    <Paper elevation={0} className={classNames(classes.root, className)}>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Typography variant="subtitle2">About Discretize</Typography>
          <List disablePadding>
            <ListItem {...listItemProps}>
              <ListItemText>
                <Link to="/" className={classes.link}>
                  Who are we?
                </Link>
              </ListItemText>
            </ListItem>
            <ListItem {...listItemProps}>
              <ListItemText>
                <Link to="/apply" className={classes.link}>
                  Apply
                </Link>
              </ListItemText>
            </ListItem>
            <ListItem {...listItemProps}>
              <ListItemText>
                <Link to="/contributors" className={classes.link}>
                  Website Contributors
                </Link>
              </ListItemText>
            </ListItem>
            <ListItem {...listItemProps}>
              <ListItemText>
                <Link
                  to="https://www.patreon.com/discretize"
                  className={classes.link}
                >
                  Patreon
                </Link>
              </ListItemText>
            </ListItem>
          </List>
        </Grid>

        <Grid item>
          <Typography variant="subtitle2">Contribute</Typography>
          <List disablePadding>
            <ListItem {...listItemProps}>
              <ListItemText>
                <Link to="/contribute" className={classes.link}>
                  How-to-guide
                </Link>
              </ListItemText>
            </ListItem>
            <ListItem {...listItemProps}>
              <ListItemText>
                <Link
                  to="https://staging.discretize.eu/cms"
                  className={classes.link}
                >
                  CMS
                </Link>
              </ListItemText>
            </ListItem>
          </List>
        </Grid>

        <Grid item>
          <Typography variant="subtitle2">Legal</Typography>
          <List disablePadding>
            <ListItem {...listItemProps}>
              <ListItemText>
                <Link to="/legal" className={classes.link}>
                  Legal Notice
                </Link>
              </ListItemText>
            </ListItem>
            <ListItem {...listItemProps}>
              <ListItemText>
                <Link to="/legal" className={classes.link}>
                  Privacy Policy
                </Link>
              </ListItemText>
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default Footer;
